import { IconButton, TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useTheme } from "@material-ui/styles";
import AddRowButton from "components/common/AddRowButton";
import {
  StyledTableCell,
  TableRowHead,
  UploadButton,
  useStyles,
} from "components/request-document/components/Commons";
import SelectCountryDialog from "components/request-document/components/SelectCountryDialog";
import useModalLoading from "libs/hooks/useModalLoading";
import { openFileById } from "libs/utils/file";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";
import FileService from "services/FileService";

export default function EducationSection({ defaultEducationData, formik }) {
  const classes = useStyles();
  const theme = useTheme();
  const masterData = useSelector(selectMasterData);
  const canEdit = useSelector(canEditForm);
  const { showLoading, hideLoading } = useModalLoading();
  const educationConfig = get(masterData, "educationConfig", []);
  const countryConfig = get(masterData, "countryConfig", []);

  const EducationData = get(formik.values, "document.Education.data", []);

  return (
    <TableRow style={{ margin: 0, padding: 0 }}>
      <StyledTableCell colSpan={7} style={{ margin: 0, padding: 0, border: 0 }}>
        <TableRow>
          <StyledTableCell colSpan={7}>
            <div className={classes.cellContent}>
              <div className={classes.wrapField}>
                <InputLabel>Education</InputLabel>
              </div>
            </div>
          </StyledTableCell>
        </TableRow>

        <TableRowHead>
          <StyledTableCell>
            <InputLabel>Education</InputLabel>
          </StyledTableCell>
          <StyledTableCell>
            <InputLabel>Year of graduation</InputLabel>
          </StyledTableCell>
          <StyledTableCell>
            <InputLabel>Name of educational institution</InputLabel>
          </StyledTableCell>
          <StyledTableCell>
            <InputLabel>Country</InputLabel>
          </StyledTableCell>
          <StyledTableCell>
            <InputLabel>Field of study</InputLabel>
          </StyledTableCell>
          <StyledTableCell colSpan={2}>
            <InputLabel>File Upload ( PDF, JPG )</InputLabel>
          </StyledTableCell>
        </TableRowHead>

        {EducationData.map((data, index) => {
          if (!data.Status) return null;
          return (
            <TableRow key={index}>
              <StyledTableCell>
                <FormControl
                  variant="outlined"
                  className={classes.textField}
                  style={{ width: 100 }}
                  error={isError(
                    `document.Education.data.${index}.educationName`,
                    formik
                  )}
                >
                  <InputLabel style={{ backgroundColor: "#ffffff" }} shrink>
                    Education
                  </InputLabel>
                  <Select
                    disabled={!canEdit}
                    label="Education"
                    name={`document.Education.data.${index}.educationName`}
                    value={get(
                      formik.values,
                      `document.Education.data.${index}.educationName`,
                      ""
                    )}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {educationConfig.map((education) => (
                      <MenuItem
                        value={education.educationConfigID}
                        key={education.educationConfigID}
                      >
                        {education.educationConfigName}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText
                    error={isError(
                      `document.Education.data.${index}.educationName`,
                      formik
                    )}
                  >
                    {getErrorMessage(
                      `document.Education.data.${index}.educationName`,
                      formik
                    )}
                  </FormHelperText>
                </FormControl>
              </StyledTableCell>
              <StyledTableCell>
                <TextField
                  disabled={!canEdit}
                  variant="outlined"
                  className={classes.textField}
                  style={{ width: 100 }}
                  placeholder=""
                  name={`document.Education.data.${index}.YearOfGraduation`}
                  value={get(
                    formik.values,
                    `document.Education.data.${index}.YearOfGraduation`,
                    ""
                  )}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError(
                    `document.Education.data.${index}.YearOfGraduation`,
                    formik
                  )}
                  helperText={getErrorMessage(
                    `document.Education.data.${index}.YearOfGraduation`,
                    formik
                  )}
                />
              </StyledTableCell>
              <StyledTableCell>
                <TextField
                  disabled={!canEdit}
                  variant="outlined"
                  className={classes.textField}
                  placeholder=""
                  name={`document.Education.data.${index}.NameOfEducation`}
                  value={get(
                    formik.values,
                    `document.Education.data.${index}.NameOfEducation`,
                    ""
                  )}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError(
                    `document.Education.data.${index}.NameOfEducation`,
                    formik
                  )}
                  helperText={getErrorMessage(
                    `document.Education.data.${index}.NameOfEducation`,
                    formik
                  )}
                />
              </StyledTableCell>
              <StyledTableCell>
                <SelectCountryDialog
                  disabled={!canEdit}
                  formik={formik}
                  countryFieldName={`document.Education.data.${index}.countryId`}
                  cityFieldName={`document.Education.data.${index}.CityID`}
                />
              </StyledTableCell>
              <StyledTableCell>
                <TextField
                  disabled={!canEdit}
                  variant="outlined"
                  className={classes.textField}
                  // style={{ width: 120 }}
                  placeholder=""
                  name={`document.Education.data.${index}.FieldOfStudy`}
                  value={get(
                    formik.values,
                    `document.Education.data.${index}.FieldOfStudy`,
                    ""
                  )}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError(
                    `document.Education.data.${index}.FieldOfStudy`,
                    formik
                  )}
                  helperText={getErrorMessage(
                    `document.Education.data.${index}.FieldOfStudy`,
                    formik
                  )}
                />
              </StyledTableCell>

              <StyledTableCell>
                <div
                  className={classes.textField}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: 75,
                  }}
                >
                  <UploadButton
                    disabled={!canEdit}
                    title={
                      get(
                        formik.values,
                        `document.Education.data.${index}.FileID`,
                        ""
                      )
                        ? "Edit"
                        : "+ Add"
                    }
                    id={`upload-${index}`}
                    onChange={async (event) => {
                      showLoading();
                      try {
                        const response = await FileService.uploadFile({
                          file: event.target.files[0],
                          Status: true,
                        });

                        let OcrText = "";
                        let IsDetect = false;

                        try {
                          // const ocrText = await OCRService.read(
                          //   event.target.files[0]
                          // );
                          // const checkTextInOCR = educationConfig
                          //   .map((v) => v.educationConfigName)
                          //   .filter((educationConfigName) =>
                          //     ocrText?.results?.includes(educationConfigName)
                          //   )
                          //   .join("|");
                          // OcrText = checkTextInOCR;
                          // IsDetect = checkTextInOCR !== "";
                        } catch (error) {
                          console.log("Check OCR error", error);
                        }

                        const fileId = response.results?.fileID;
                        const [filename, ext] =
                          event.target.files[0].name.split(".");

                        formik.setFieldValue(
                          `document.Education.data.${index}.FileID`,
                          fileId
                        );
                        formik.setFieldValue(
                          `document.Education.data.${index}.filename`,
                          filename
                        );
                        formik.setFieldValue(
                          `document.Education.data.${index}.ext`,
                          `.${ext}`
                        );
                        formik.setFieldValue(
                          `document.Education.data.${index}.OcrText`,
                          OcrText
                        );
                        formik.setFieldValue(
                          `document.Education.data.${index}.IsDetect`,
                          IsDetect
                        );
                      } catch (error) {
                        console.log("Upload error", error);
                      } finally {
                        hideLoading();
                      }
                    }}
                  />
                  {get(
                    formik.values,
                    `document.Education.data.${index}.FileID`,
                    ""
                  ) && (
                    <IconButton
                      style={{ width: 40 }}
                      size="small"
                      onClick={async () => {
                        const fileId = get(
                          formik.values,
                          `document.Education.data.${index}.FileID`,
                          ""
                        );
                        openFileById(fileId);
                      }}
                    >
                      <VisibilityIcon />
                    </IconButton>
                  )}
                </div>
                <FormHelperText
                  error={isError(
                    `document.Education.data.${index}.FileID`,
                    formik
                  )}
                >
                  {getErrorMessage(
                    `document.Education.data.${index}.FileID`,
                    formik
                  )}
                </FormHelperText>
              </StyledTableCell>
              <StyledTableCell align="center" colSpan={2}>
                {index === 0 ? (
                  <div style={{ width: 35 }} />
                ) : (
                  <>
                    <IconButton
                      disabled={!canEdit}
                      style={{ width: 35, color: theme.palette.error.main }}
                      size="small"
                      onClick={async () => {
                        if (
                          get(
                            formik.values,
                            `document.Education.data.${index}.educationId`,
                            ""
                          )
                        ) {
                          formik.setFieldValue(
                            `document.Education.data[${index}].Status`,
                            false
                          );
                        } else {
                          formik.setFieldValue(
                            "document.Education.data",
                            EducationData.filter((__, i) => i !== index)
                          );
                        }
                      }}
                    >
                      <DeleteForeverIcon />
                    </IconButton>
                    <FormHelperText error={false}> </FormHelperText>
                  </>
                )}
              </StyledTableCell>
            </TableRow>
          );
        })}

        <TableRow>
          <StyledTableCell colSpan={7}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AddRowButton
                disabled={!canEdit}
                onClick={() => {
                  formik.setFieldValue("document.Education.data", [
                    ...EducationData,
                    defaultEducationData,
                  ]);
                }}
              />
            </div>
          </StyledTableCell>
        </TableRow>
      </StyledTableCell>
    </TableRow>
  );
}
